package me.repeater64.advancedmpkeditor.backend.data_object.item

import me.repeater64.advancedmpkeditor.backend.presets_examples.rawItem

enum class MinecraftItemCategory(val displayName: String, val items: List<MinecraftItem>, val isSpecificArmorSlotCategory: Boolean = false) {
    ALL("All Items", listOf(
        rawItem("acacia_boat"),
        rawItem("acacia_button"),
        rawItem("acacia_door"),
        rawItem("acacia_fence"),
        rawItem("acacia_fence_gate"),
        rawItem("acacia_leaves"),
        rawItem("acacia_log"),
        rawItem("acacia_planks"),
        rawItem("acacia_pressure_plate"),
        rawItem("acacia_sapling"),
        rawItem("acacia_sign"),
        rawItem("acacia_slab"),
        rawItem("acacia_stairs"),
        rawItem("acacia_trapdoor"),
        rawItem("acacia_wood"),
        rawItem("activator_rail"),
        rawItem("allium"),
        rawItem("ancient_debris"),
        rawItem("andesite"),
        rawItem("andesite_slab"),
        rawItem("andesite_stairs"),
        rawItem("andesite_wall"),
        rawItem("anvil"),
        rawItem("apple"),
        rawItem("armor_stand"),
        rawItem("arrow"),
        rawItem("azure_bluet"),
        rawItem("baked_potato"),
        rawItem("bamboo"),
        rawItem("barrel"),
//        rawItem("barrier"),
        rawItem("basalt"),
        rawItem("bat_spawn_egg"),
        rawItem("beacon"),
//        rawItem("bedrock"),
        rawItem("bee_nest"),
        rawItem("bee_spawn_egg"),
        rawItem("beef"),
        rawItem("beehive"),
        rawItem("beetroot"),
        rawItem("beetroot_seeds"),
        rawItem("beetroot_soup"),
        rawItem("bell"),
        rawItem("birch_boat"),
        rawItem("birch_button"),
        rawItem("birch_door"),
        rawItem("birch_fence"),
        rawItem("birch_fence_gate"),
        rawItem("birch_leaves"),
        rawItem("birch_log"),
        rawItem("birch_planks"),
        rawItem("birch_pressure_plate"),
        rawItem("birch_sapling"),
        rawItem("birch_sign"),
        rawItem("birch_slab"),
        rawItem("birch_stairs"),
        rawItem("birch_trapdoor"),
        rawItem("birch_wood"),
        rawItem("black_banner"),
        rawItem("black_bed"),
        rawItem("black_carpet"),
        rawItem("black_concrete"),
        rawItem("black_concrete_powder"),
        rawItem("black_dye"),
        rawItem("black_glazed_terracotta"),
        rawItem("black_shulker_box"),
        rawItem("black_stained_glass"),
        rawItem("black_stained_glass_pane"),
        rawItem("black_terracotta"),
        rawItem("black_wool"),
        rawItem("blackstone"),
        rawItem("blackstone_slab"),
        rawItem("blackstone_stairs"),
        rawItem("blackstone_wall"),
        rawItem("blast_furnace"),
        rawItem("blaze_powder"),
        rawItem("blaze_rod"),
        rawItem("blaze_spawn_egg"),
        rawItem("blue_banner"),
        rawItem("blue_bed"),
        rawItem("blue_carpet"),
        rawItem("blue_concrete"),
        rawItem("blue_concrete_powder"),
        rawItem("blue_dye"),
        rawItem("blue_glazed_terracotta"),
        rawItem("blue_ice"),
        rawItem("blue_orchid"),
        rawItem("blue_shulker_box"),
        rawItem("blue_stained_glass"),
        rawItem("blue_stained_glass_pane"),
        rawItem("blue_terracotta"),
        rawItem("blue_wool"),
        rawItem("bone"),
        rawItem("bone_block"),
        rawItem("bone_meal"),
        rawItem("book"),
        rawItem("bookshelf"),
        rawItem("bow"),
        rawItem("bowl"),
        rawItem("brain_coral"),
        rawItem("brain_coral_block"),
        rawItem("brain_coral_fan"),
        rawItem("bread"),
        rawItem("brewing_stand"),
        rawItem("brick"),
        rawItem("brick_slab"),
        rawItem("brick_stairs"),
        rawItem("brick_wall"),
        rawItem("bricks"),
        rawItem("brown_banner"),
        rawItem("brown_bed"),
        rawItem("brown_carpet"),
        rawItem("brown_concrete"),
        rawItem("brown_concrete_powder"),
        rawItem("brown_dye"),
        rawItem("brown_glazed_terracotta"),
        rawItem("brown_mushroom"),
        rawItem("brown_mushroom_block"),
        rawItem("brown_shulker_box"),
        rawItem("brown_stained_glass"),
        rawItem("brown_stained_glass_pane"),
        rawItem("brown_terracotta"),
        rawItem("brown_wool"),
        rawItem("bubble_coral"),
        rawItem("bubble_coral_block"),
        rawItem("bubble_coral_fan"),
        rawItem("bucket"),
        rawItem("cactus"),
        rawItem("cake"),
        rawItem("campfire"),
        rawItem("carrot"),
        rawItem("carrot_on_a_stick"),
        rawItem("cartography_table"),
        rawItem("carved_pumpkin"),
        rawItem("cat_spawn_egg"),
        rawItem("cauldron"),
        rawItem("cave_spider_spawn_egg"),
        rawItem("chain"),
        rawItem("chain_command_block"),
        rawItem("chainmail_boots"),
        rawItem("chainmail_chestplate"),
        rawItem("chainmail_helmet"),
        rawItem("chainmail_leggings"),
        rawItem("charcoal"),
        rawItem("chest"),
        rawItem("chest_minecart"),
        rawItem("chicken"),
        rawItem("chicken_spawn_egg"),
        rawItem("chipped_anvil"),
        rawItem("chiseled_nether_bricks"),
        rawItem("chiseled_polished_blackstone"),
        rawItem("chiseled_quartz_block"),
        rawItem("chiseled_red_sandstone"),
        rawItem("chiseled_sandstone"),
        rawItem("chiseled_stone_bricks"),
        rawItem("chorus_flower"),
        rawItem("chorus_fruit"),
        rawItem("chorus_plant"),
        rawItem("clay"),
        rawItem("clay_ball"),
        rawItem("clock"),
        rawItem("coal"),
        rawItem("coal_block"),
        rawItem("coal_ore"),
        rawItem("coarse_dirt"),
        rawItem("cobblestone"),
        rawItem("cobblestone_slab"),
        rawItem("cobblestone_stairs"),
        rawItem("cobblestone_wall"),
        rawItem("cobweb"),
        rawItem("cocoa_beans"),
        rawItem("cod"),
        rawItem("cod_bucket"),
        rawItem("cod_spawn_egg"),
        rawItem("command_block"),
        rawItem("command_block_minecart"),
        rawItem("comparator"),
        rawItem("compass"),
        rawItem("composter"),
        rawItem("conduit"),
        rawItem("cooked_beef"),
        rawItem("cooked_chicken"),
        rawItem("cooked_cod"),
        rawItem("cooked_mutton"),
        rawItem("cooked_porkchop"),
        rawItem("cooked_rabbit"),
        rawItem("cooked_salmon"),
        rawItem("cookie"),
        rawItem("cornflower"),
        rawItem("cow_spawn_egg"),
        rawItem("cracked_nether_bricks"),
        rawItem("cracked_polished_blackstone_bricks"),
        rawItem("cracked_stone_bricks"),
        rawItem("crafting_table"),
        rawItem("creeper_banner_pattern"),
        rawItem("creeper_head"),
        rawItem("creeper_spawn_egg"),
        rawItem("crimson_button"),
        rawItem("crimson_door"),
        rawItem("crimson_fence"),
        rawItem("crimson_fence_gate"),
        rawItem("crimson_fungus"),
        rawItem("crimson_hyphae"),
        rawItem("crimson_nylium"),
        rawItem("crimson_planks"),
        rawItem("crimson_pressure_plate"),
        rawItem("crimson_roots"),
        rawItem("crimson_sign"),
        rawItem("crimson_slab"),
        rawItem("crimson_stairs"),
        rawItem("crimson_stem"),
        rawItem("crimson_trapdoor"),
        rawItem("crossbow"),
        rawItem("crying_obsidian"),
        rawItem("cut_red_sandstone"),
        rawItem("cut_red_sandstone_slab"),
        rawItem("cut_sandstone"),
        rawItem("cut_sandstone_slab"),
        rawItem("cyan_banner"),
        rawItem("cyan_bed"),
        rawItem("cyan_carpet"),
        rawItem("cyan_concrete"),
        rawItem("cyan_concrete_powder"),
        rawItem("cyan_dye"),
        rawItem("cyan_glazed_terracotta"),
        rawItem("cyan_shulker_box"),
        rawItem("cyan_stained_glass"),
        rawItem("cyan_stained_glass_pane"),
        rawItem("cyan_terracotta"),
        rawItem("cyan_wool"),
        rawItem("damaged_anvil"),
        rawItem("dandelion"),
        rawItem("dark_oak_boat"),
        rawItem("dark_oak_button"),
        rawItem("dark_oak_door"),
        rawItem("dark_oak_fence"),
        rawItem("dark_oak_fence_gate"),
        rawItem("dark_oak_leaves"),
        rawItem("dark_oak_log"),
        rawItem("dark_oak_planks"),
        rawItem("dark_oak_pressure_plate"),
        rawItem("dark_oak_sapling"),
        rawItem("dark_oak_sign"),
        rawItem("dark_oak_slab"),
        rawItem("dark_oak_stairs"),
        rawItem("dark_oak_trapdoor"),
        rawItem("dark_oak_wood"),
        rawItem("dark_prismarine"),
        rawItem("dark_prismarine_slab"),
        rawItem("dark_prismarine_stairs"),
        rawItem("daylight_detector"),
        rawItem("dead_brain_coral"),
        rawItem("dead_brain_coral_block"),
        rawItem("dead_brain_coral_fan"),
        rawItem("dead_bubble_coral"),
        rawItem("dead_bubble_coral_block"),
        rawItem("dead_bubble_coral_fan"),
        rawItem("dead_bush"),
        rawItem("dead_fire_coral"),
        rawItem("dead_fire_coral_block"),
        rawItem("dead_fire_coral_fan"),
        rawItem("dead_horn_coral"),
        rawItem("dead_horn_coral_block"),
        rawItem("dead_horn_coral_fan"),
        rawItem("dead_tube_coral"),
        rawItem("dead_tube_coral_block"),
        rawItem("dead_tube_coral_fan"),
        rawItem("debug_stick"),
        rawItem("detector_rail"),
        rawItem("diamond"),
        rawItem("diamond_axe"),
        rawItem("diamond_block"),
        rawItem("diamond_boots"),
        rawItem("diamond_chestplate"),
        rawItem("diamond_helmet"),
        rawItem("diamond_hoe"),
        rawItem("diamond_horse_armor"),
        rawItem("diamond_leggings"),
        rawItem("diamond_ore"),
        rawItem("diamond_pickaxe"),
        rawItem("diamond_shovel"),
        rawItem("diamond_sword"),
        rawItem("diorite"),
        rawItem("diorite_slab"),
        rawItem("diorite_stairs"),
        rawItem("diorite_wall"),
        rawItem("dirt"),
        rawItem("dispenser"),
        rawItem("dolphin_spawn_egg"),
        rawItem("donkey_spawn_egg"),
        rawItem("dragon_breath"),
        rawItem("dragon_egg"),
        rawItem("dragon_head"),
        rawItem("dried_kelp"),
        rawItem("dried_kelp_block"),
        rawItem("dropper"),
        rawItem("drowned_spawn_egg"),
        rawItem("egg"),
        rawItem("elder_guardian_spawn_egg"),
        rawItem("elytra"),
        rawItem("emerald"),
        rawItem("emerald_block"),
        rawItem("emerald_ore"),
        rawItem("enchanted_book"),
        rawItem("enchanted_golden_apple"),
        rawItem("enchanting_table"),
        rawItem("end_crystal"),
        rawItem("end_portal_frame"),
        rawItem("end_rod"),
        rawItem("end_stone"),
        rawItem("end_stone_brick_slab"),
        rawItem("end_stone_brick_stairs"),
        rawItem("end_stone_brick_wall"),
        rawItem("end_stone_bricks"),
        rawItem("ender_chest"),
        rawItem("ender_eye"),
        rawItem("ender_pearl"),
        rawItem("enderman_spawn_egg"),
        rawItem("endermite_spawn_egg"),
        rawItem("evoker_spawn_egg"),
        rawItem("experience_bottle"),
        rawItem("farmland"),
        rawItem("feather"),
        rawItem("fermented_spider_eye"),
        rawItem("fern"),
        rawItem("filled_map"),
        rawItem("fire_charge"),
        rawItem("fire_coral"),
        rawItem("fire_coral_block"),
        rawItem("fire_coral_fan"),
        rawItem("firework_rocket"),
        rawItem("firework_star"),
        rawItem("fishing_rod"),
        rawItem("fletching_table"),
        rawItem("flint"),
        rawItem("flint_and_steel"),
        rawItem("flower_banner_pattern"),
        rawItem("flower_pot"),
        rawItem("fox_spawn_egg"),
        rawItem("furnace"),
        rawItem("furnace_minecart"),
        rawItem("ghast_spawn_egg"),
        rawItem("ghast_tear"),
        rawItem("gilded_blackstone"),
        rawItem("glass"),
        rawItem("glass_bottle"),
        rawItem("glass_pane"),
        rawItem("glistering_melon_slice"),
        rawItem("globe_banner_pattern"),
        rawItem("glowstone"),
        rawItem("glowstone_dust"),
        rawItem("gold_block"),
        rawItem("gold_ingot"),
        rawItem("gold_nugget"),
        rawItem("gold_ore"),
        rawItem("golden_apple"),
        rawItem("golden_axe"),
        rawItem("golden_boots"),
        rawItem("golden_carrot"),
        rawItem("golden_chestplate"),
        rawItem("golden_helmet"),
        rawItem("golden_hoe"),
        rawItem("golden_horse_armor"),
        rawItem("golden_leggings"),
        rawItem("golden_pickaxe"),
        rawItem("golden_shovel"),
        rawItem("golden_sword"),
        rawItem("granite"),
        rawItem("granite_slab"),
        rawItem("granite_stairs"),
        rawItem("granite_wall"),
        rawItem("grass"),
        rawItem("grass_block"),
        rawItem("grass_path"),
        rawItem("gravel"),
        rawItem("gray_banner"),
        rawItem("gray_bed"),
        rawItem("gray_carpet"),
        rawItem("gray_concrete"),
        rawItem("gray_concrete_powder"),
        rawItem("gray_dye"),
        rawItem("gray_glazed_terracotta"),
        rawItem("gray_shulker_box"),
        rawItem("gray_stained_glass"),
        rawItem("gray_stained_glass_pane"),
        rawItem("gray_terracotta"),
        rawItem("gray_wool"),
        rawItem("green_banner"),
        rawItem("green_bed"),
        rawItem("green_carpet"),
        rawItem("green_concrete"),
        rawItem("green_concrete_powder"),
        rawItem("green_dye"),
        rawItem("green_glazed_terracotta"),
        rawItem("green_shulker_box"),
        rawItem("green_stained_glass"),
        rawItem("green_stained_glass_pane"),
        rawItem("green_terracotta"),
        rawItem("green_wool"),
        rawItem("grindstone"),
        rawItem("guardian_spawn_egg"),
        rawItem("gunpowder"),
        rawItem("hay_block"),
        rawItem("heart_of_the_sea"),
        rawItem("heavy_weighted_pressure_plate"),
        rawItem("hoglin_spawn_egg"),
        rawItem("honey_block"),
        rawItem("honey_bottle"),
        rawItem("honeycomb"),
        rawItem("honeycomb_block"),
        rawItem("hopper"),
        rawItem("hopper_minecart"),
        rawItem("horn_coral"),
        rawItem("horn_coral_block"),
        rawItem("horn_coral_fan"),
        rawItem("horse_spawn_egg"),
        rawItem("husk_spawn_egg"),
        rawItem("ice"),
        rawItem("infested_chiseled_stone_bricks"),
        rawItem("infested_cobblestone"),
        rawItem("infested_cracked_stone_bricks"),
        rawItem("infested_mossy_stone_bricks"),
        rawItem("infested_stone"),
        rawItem("infested_stone_bricks"),
        rawItem("ink_sac"),
        rawItem("iron_axe"),
        rawItem("iron_bars"),
        rawItem("iron_block"),
        rawItem("iron_boots"),
        rawItem("iron_chestplate"),
        rawItem("iron_door"),
        rawItem("iron_helmet"),
        rawItem("iron_hoe"),
        rawItem("iron_horse_armor"),
        rawItem("iron_ingot"),
        rawItem("iron_leggings"),
        rawItem("iron_nugget"),
        rawItem("iron_ore"),
        rawItem("iron_pickaxe"),
        rawItem("iron_shovel"),
        rawItem("iron_sword"),
        rawItem("iron_trapdoor"),
        rawItem("item_frame"),
        rawItem("jack_o_lantern"),
        rawItem("jigsaw"),
        rawItem("jukebox"),
        rawItem("jungle_boat"),
        rawItem("jungle_button"),
        rawItem("jungle_door"),
        rawItem("jungle_fence"),
        rawItem("jungle_fence_gate"),
        rawItem("jungle_leaves"),
        rawItem("jungle_log"),
        rawItem("jungle_planks"),
        rawItem("jungle_pressure_plate"),
        rawItem("jungle_sapling"),
        rawItem("jungle_sign"),
        rawItem("jungle_slab"),
        rawItem("jungle_stairs"),
        rawItem("jungle_trapdoor"),
        rawItem("jungle_wood"),
        rawItem("kelp"),
        rawItem("knowledge_book"),
        rawItem("ladder"),
        rawItem("lantern"),
        rawItem("lapis_block"),
        rawItem("lapis_lazuli"),
        rawItem("lapis_ore"),
        rawItem("large_fern"),
        rawItem("lava_bucket"),
        rawItem("lead"),
        rawItem("leather"),
        rawItem("leather_boots"),
        rawItem("leather_chestplate"),
        rawItem("leather_helmet"),
        rawItem("leather_horse_armor"),
        rawItem("leather_leggings"),
        rawItem("lectern"),
        rawItem("lever"),
        rawItem("light_blue_banner"),
        rawItem("light_blue_bed"),
        rawItem("light_blue_carpet"),
        rawItem("light_blue_concrete"),
        rawItem("light_blue_concrete_powder"),
        rawItem("light_blue_dye"),
        rawItem("light_blue_glazed_terracotta"),
        rawItem("light_blue_shulker_box"),
        rawItem("light_blue_stained_glass"),
        rawItem("light_blue_stained_glass_pane"),
        rawItem("light_blue_terracotta"),
        rawItem("light_blue_wool"),
        rawItem("light_gray_banner"),
        rawItem("light_gray_bed"),
        rawItem("light_gray_carpet"),
        rawItem("light_gray_concrete"),
        rawItem("light_gray_concrete_powder"),
        rawItem("light_gray_dye"),
        rawItem("light_gray_glazed_terracotta"),
        rawItem("light_gray_shulker_box"),
        rawItem("light_gray_stained_glass"),
        rawItem("light_gray_stained_glass_pane"),
        rawItem("light_gray_terracotta"),
        rawItem("light_gray_wool"),
        rawItem("light_weighted_pressure_plate"),
        rawItem("lilac"),
        rawItem("lily_of_the_valley"),
        rawItem("lily_pad"),
        rawItem("lime_banner"),
        rawItem("lime_bed"),
        rawItem("lime_carpet"),
        rawItem("lime_concrete"),
        rawItem("lime_concrete_powder"),
        rawItem("lime_dye"),
        rawItem("lime_glazed_terracotta"),
        rawItem("lime_shulker_box"),
        rawItem("lime_stained_glass"),
        rawItem("lime_stained_glass_pane"),
        rawItem("lime_terracotta"),
        rawItem("lime_wool"),
        rawItem("lingering_potion"),
        rawItem("llama_spawn_egg"),
        rawItem("lodestone"),
        rawItem("loom"),
        rawItem("magenta_banner"),
        rawItem("magenta_bed"),
        rawItem("magenta_carpet"),
        rawItem("magenta_concrete"),
        rawItem("magenta_concrete_powder"),
        rawItem("magenta_dye"),
        rawItem("magenta_glazed_terracotta"),
        rawItem("magenta_shulker_box"),
        rawItem("magenta_stained_glass"),
        rawItem("magenta_stained_glass_pane"),
        rawItem("magenta_terracotta"),
        rawItem("magenta_wool"),
        rawItem("magma_block"),
        rawItem("magma_cream"),
        rawItem("magma_cube_spawn_egg"),
        rawItem("map"),
        rawItem("melon"),
        rawItem("melon_seeds"),
        rawItem("melon_slice"),
        rawItem("milk_bucket"),
        rawItem("minecart"),
        rawItem("mojang_banner_pattern"),
        rawItem("mooshroom_spawn_egg"),
        rawItem("mossy_cobblestone"),
        rawItem("mossy_cobblestone_slab"),
        rawItem("mossy_cobblestone_stairs"),
        rawItem("mossy_cobblestone_wall"),
        rawItem("mossy_stone_brick_slab"),
        rawItem("mossy_stone_brick_stairs"),
        rawItem("mossy_stone_brick_wall"),
        rawItem("mossy_stone_bricks"),
        rawItem("mule_spawn_egg"),
        rawItem("mushroom_stem"),
        rawItem("mushroom_stew"),
        rawItem("music_disc_11"),
        rawItem("music_disc_13"),
        rawItem("music_disc_blocks"),
        rawItem("music_disc_cat"),
        rawItem("music_disc_chirp"),
        rawItem("music_disc_far"),
        rawItem("music_disc_mall"),
        rawItem("music_disc_mellohi"),
        rawItem("music_disc_pigstep"),
        rawItem("music_disc_stal"),
        rawItem("music_disc_strad"),
        rawItem("music_disc_wait"),
        rawItem("music_disc_ward"),
        rawItem("mutton"),
        rawItem("mycelium"),
        rawItem("name_tag"),
        rawItem("nautilus_shell"),
        rawItem("nether_brick"),
        rawItem("nether_brick_fence"),
        rawItem("nether_brick_slab"),
        rawItem("nether_brick_stairs"),
        rawItem("nether_brick_wall"),
        rawItem("nether_bricks"),
        rawItem("nether_gold_ore"),
        rawItem("nether_quartz_ore"),
        rawItem("nether_sprouts"),
        rawItem("nether_star"),
        rawItem("nether_wart"),
        rawItem("nether_wart_block"),
        rawItem("netherite_axe"),
        rawItem("netherite_block"),
        rawItem("netherite_boots"),
        rawItem("netherite_chestplate"),
        rawItem("netherite_helmet"),
        rawItem("netherite_hoe"),
        rawItem("netherite_ingot"),
        rawItem("netherite_leggings"),
        rawItem("netherite_pickaxe"),
        rawItem("netherite_scrap"),
        rawItem("netherite_shovel"),
        rawItem("netherite_sword"),
        rawItem("netherrack"),
        rawItem("note_block"),
        rawItem("oak_boat"),
        rawItem("oak_button"),
        rawItem("oak_door"),
        rawItem("oak_fence"),
        rawItem("oak_fence_gate"),
        rawItem("oak_leaves"),
        rawItem("oak_log"),
        rawItem("oak_planks"),
        rawItem("oak_pressure_plate"),
        rawItem("oak_sapling"),
        rawItem("oak_sign"),
        rawItem("oak_slab"),
        rawItem("oak_stairs"),
        rawItem("oak_trapdoor"),
        rawItem("oak_wood"),
        rawItem("observer"),
        rawItem("obsidian"),
        rawItem("ocelot_spawn_egg"),
        rawItem("orange_banner"),
        rawItem("orange_bed"),
        rawItem("orange_carpet"),
        rawItem("orange_concrete"),
        rawItem("orange_concrete_powder"),
        rawItem("orange_dye"),
        rawItem("orange_glazed_terracotta"),
        rawItem("orange_shulker_box"),
        rawItem("orange_stained_glass"),
        rawItem("orange_stained_glass_pane"),
        rawItem("orange_terracotta"),
        rawItem("orange_tulip"),
        rawItem("orange_wool"),
        rawItem("oxeye_daisy"),
        rawItem("packed_ice"),
        rawItem("painting"),
        rawItem("panda_spawn_egg"),
        rawItem("paper"),
        rawItem("parrot_spawn_egg"),
        rawItem("peony"),
        rawItem("petrified_oak_slab"),
        rawItem("phantom_membrane"),
        rawItem("phantom_spawn_egg"),
        rawItem("pig_spawn_egg"),
        rawItem("piglin_banner_pattern"),
        rawItem("piglin_brute_spawn_egg"),
        rawItem("piglin_spawn_egg"),
        rawItem("pillager_spawn_egg"),
        rawItem("pink_banner"),
        rawItem("pink_bed"),
        rawItem("pink_carpet"),
        rawItem("pink_concrete"),
        rawItem("pink_concrete_powder"),
        rawItem("pink_dye"),
        rawItem("pink_glazed_terracotta"),
        rawItem("pink_shulker_box"),
        rawItem("pink_stained_glass"),
        rawItem("pink_stained_glass_pane"),
        rawItem("pink_terracotta"),
        rawItem("pink_tulip"),
        rawItem("pink_wool"),
        rawItem("piston"),
        rawItem("player_head"),
        rawItem("podzol"),
        rawItem("poisonous_potato"),
        rawItem("polar_bear_spawn_egg"),
        rawItem("polished_andesite"),
        rawItem("polished_andesite_slab"),
        rawItem("polished_andesite_stairs"),
        rawItem("polished_basalt"),
        rawItem("polished_blackstone"),
        rawItem("polished_blackstone_brick_slab"),
        rawItem("polished_blackstone_brick_stairs"),
        rawItem("polished_blackstone_brick_wall"),
        rawItem("polished_blackstone_bricks"),
        rawItem("polished_blackstone_button"),
        rawItem("polished_blackstone_pressure_plate"),
        rawItem("polished_blackstone_slab"),
        rawItem("polished_blackstone_stairs"),
        rawItem("polished_blackstone_wall"),
        rawItem("polished_diorite"),
        rawItem("polished_diorite_slab"),
        rawItem("polished_diorite_stairs"),
        rawItem("polished_granite"),
        rawItem("polished_granite_slab"),
        rawItem("polished_granite_stairs"),
        rawItem("popped_chorus_fruit"),
        rawItem("poppy"),
        rawItem("porkchop"),
        rawItem("potato"),
        rawItem("potion"),
        rawItem("powered_rail"),
        rawItem("prismarine"),
        rawItem("prismarine_brick_slab"),
        rawItem("prismarine_brick_stairs"),
        rawItem("prismarine_bricks"),
        rawItem("prismarine_crystals"),
        rawItem("prismarine_shard"),
        rawItem("prismarine_slab"),
        rawItem("prismarine_stairs"),
        rawItem("prismarine_wall"),
        rawItem("pufferfish"),
        rawItem("pufferfish_bucket"),
        rawItem("pufferfish_spawn_egg"),
        rawItem("pumpkin"),
        rawItem("pumpkin_pie"),
        rawItem("pumpkin_seeds"),
        rawItem("purple_banner"),
        rawItem("purple_bed"),
        rawItem("purple_carpet"),
        rawItem("purple_concrete"),
        rawItem("purple_concrete_powder"),
        rawItem("purple_dye"),
        rawItem("purple_glazed_terracotta"),
        rawItem("purple_shulker_box"),
        rawItem("purple_stained_glass"),
        rawItem("purple_stained_glass_pane"),
        rawItem("purple_terracotta"),
        rawItem("purple_wool"),
        rawItem("purpur_block"),
        rawItem("purpur_pillar"),
        rawItem("purpur_slab"),
        rawItem("purpur_stairs"),
        rawItem("quartz"),
        rawItem("quartz_block"),
        rawItem("quartz_bricks"),
        rawItem("quartz_pillar"),
        rawItem("quartz_slab"),
        rawItem("quartz_stairs"),
        rawItem("rabbit"),
        rawItem("rabbit_foot"),
        rawItem("rabbit_hide"),
        rawItem("rabbit_spawn_egg"),
        rawItem("rabbit_stew"),
        rawItem("rail"),
        rawItem("ravager_spawn_egg"),
        rawItem("red_banner"),
        rawItem("red_bed"),
        rawItem("red_carpet"),
        rawItem("red_concrete"),
        rawItem("red_concrete_powder"),
        rawItem("red_dye"),
        rawItem("red_glazed_terracotta"),
        rawItem("red_mushroom"),
        rawItem("red_mushroom_block"),
        rawItem("red_nether_brick_slab"),
        rawItem("red_nether_brick_stairs"),
        rawItem("red_nether_brick_wall"),
        rawItem("red_nether_bricks"),
        rawItem("red_sand"),
        rawItem("red_sandstone"),
        rawItem("red_sandstone_slab"),
        rawItem("red_sandstone_stairs"),
        rawItem("red_sandstone_wall"),
        rawItem("red_shulker_box"),
        rawItem("red_stained_glass"),
        rawItem("red_stained_glass_pane"),
        rawItem("red_terracotta"),
        rawItem("red_tulip"),
        rawItem("red_wool"),
        rawItem("redstone"),
        rawItem("redstone_block"),
        rawItem("redstone_lamp"),
        rawItem("redstone_ore"),
        rawItem("redstone_torch"),
        rawItem("repeater"),
        rawItem("repeating_command_block"),
        rawItem("respawn_anchor"),
        rawItem("rose_bush"),
        rawItem("rotten_flesh"),
        rawItem("saddle"),
        rawItem("salmon"),
        rawItem("salmon_bucket"),
        rawItem("salmon_spawn_egg"),
        rawItem("sand"),
        rawItem("sandstone"),
        rawItem("sandstone_slab"),
        rawItem("sandstone_stairs"),
        rawItem("sandstone_wall"),
        rawItem("scaffolding"),
        rawItem("scute"),
        rawItem("sea_lantern"),
        rawItem("sea_pickle"),
        rawItem("seagrass"),
        rawItem("shears"),
        rawItem("sheep_spawn_egg"),
        rawItem("shield"),
        rawItem("shroomlight"),
        rawItem("shulker_box"),
        rawItem("shulker_shell"),
        rawItem("shulker_spawn_egg"),
        rawItem("silverfish_spawn_egg"),
        rawItem("skeleton_horse_spawn_egg"),
        rawItem("skeleton_skull"),
        rawItem("skeleton_spawn_egg"),
        rawItem("skull_banner_pattern"),
        rawItem("slime_ball"),
        rawItem("slime_block"),
        rawItem("slime_spawn_egg"),
        rawItem("smithing_table"),
        rawItem("smoker"),
        rawItem("smooth_quartz"),
        rawItem("smooth_quartz_slab"),
        rawItem("smooth_quartz_stairs"),
        rawItem("smooth_red_sandstone"),
        rawItem("smooth_red_sandstone_slab"),
        rawItem("smooth_red_sandstone_stairs"),
        rawItem("smooth_sandstone"),
        rawItem("smooth_sandstone_slab"),
        rawItem("smooth_sandstone_stairs"),
        rawItem("smooth_stone"),
        rawItem("smooth_stone_slab"),
        rawItem("snow"),
        rawItem("snow_block"),
        rawItem("snowball"),
        rawItem("soul_campfire"),
        rawItem("soul_lantern"),
        rawItem("soul_sand"),
        rawItem("soul_soil"),
        rawItem("soul_torch"),
        rawItem("spawner"),
        rawItem("spectral_arrow"),
        rawItem("spider_eye"),
        rawItem("spider_spawn_egg"),
        rawItem("splash_potion"),
        rawItem("sponge"),
        rawItem("spruce_boat"),
        rawItem("spruce_button"),
        rawItem("spruce_door"),
        rawItem("spruce_fence"),
        rawItem("spruce_fence_gate"),
        rawItem("spruce_leaves"),
        rawItem("spruce_log"),
        rawItem("spruce_planks"),
        rawItem("spruce_pressure_plate"),
        rawItem("spruce_sapling"),
        rawItem("spruce_sign"),
        rawItem("spruce_slab"),
        rawItem("spruce_stairs"),
        rawItem("spruce_trapdoor"),
        rawItem("spruce_wood"),
        rawItem("squid_spawn_egg"),
        rawItem("stick"),
        rawItem("sticky_piston"),
        rawItem("stone"),
        rawItem("stone_axe"),
        rawItem("stone_brick_slab"),
        rawItem("stone_brick_stairs"),
        rawItem("stone_brick_wall"),
        rawItem("stone_bricks"),
        rawItem("stone_button"),
        rawItem("stone_hoe"),
        rawItem("stone_pickaxe"),
        rawItem("stone_pressure_plate"),
        rawItem("stone_shovel"),
        rawItem("stone_slab"),
        rawItem("stone_stairs"),
        rawItem("stone_sword"),
        rawItem("stonecutter"),
        rawItem("stray_spawn_egg"),
        rawItem("strider_spawn_egg"),
        rawItem("string"),
        rawItem("stripped_acacia_log"),
        rawItem("stripped_acacia_wood"),
        rawItem("stripped_birch_log"),
        rawItem("stripped_birch_wood"),
        rawItem("stripped_crimson_hyphae"),
        rawItem("stripped_crimson_stem"),
        rawItem("stripped_dark_oak_log"),
        rawItem("stripped_dark_oak_wood"),
        rawItem("stripped_jungle_log"),
        rawItem("stripped_jungle_wood"),
        rawItem("stripped_oak_log"),
        rawItem("stripped_oak_wood"),
        rawItem("stripped_spruce_log"),
        rawItem("stripped_spruce_wood"),
        rawItem("stripped_warped_hyphae"),
        rawItem("stripped_warped_stem"),
        rawItem("structure_block"),
        rawItem("structure_void"),
        rawItem("sugar"),
        rawItem("sugar_cane"),
        rawItem("sunflower"),
        rawItem("suspicious_stew"),
        rawItem("sweet_berries"),
        rawItem("tall_grass"),
        rawItem("target"),
        rawItem("terracotta"),
        rawItem("tipped_arrow"),
        rawItem("tnt"),
        rawItem("tnt_minecart"),
        rawItem("torch"),
        rawItem("totem_of_undying"),
        rawItem("trader_llama_spawn_egg"),
        rawItem("trapped_chest"),
        rawItem("trident"),
        rawItem("tripwire_hook"),
        rawItem("tropical_fish"),
        rawItem("tropical_fish_bucket"),
        rawItem("tropical_fish_spawn_egg"),
        rawItem("tube_coral"),
        rawItem("tube_coral_block"),
        rawItem("tube_coral_fan"),
        rawItem("turtle_egg"),
        rawItem("turtle_helmet"),
        rawItem("turtle_spawn_egg"),
        rawItem("vex_spawn_egg"),
        rawItem("villager_spawn_egg"),
        rawItem("vindicator_spawn_egg"),
        rawItem("vine"),
        rawItem("wandering_trader_spawn_egg"),
        rawItem("warped_button"),
        rawItem("warped_door"),
        rawItem("warped_fence"),
        rawItem("warped_fence_gate"),
        rawItem("warped_fungus"),
        rawItem("warped_fungus_on_a_stick"),
        rawItem("warped_hyphae"),
        rawItem("warped_nylium"),
        rawItem("warped_planks"),
        rawItem("warped_pressure_plate"),
        rawItem("warped_roots"),
        rawItem("warped_sign"),
        rawItem("warped_slab"),
        rawItem("warped_stairs"),
        rawItem("warped_stem"),
        rawItem("warped_trapdoor"),
        rawItem("warped_wart_block"),
        rawItem("water_bucket"),
        rawItem("weeping_vines"),
        rawItem("wet_sponge"),
        rawItem("wheat"),
        rawItem("wheat_seeds"),
        rawItem("white_banner"),
        rawItem("white_bed"),
        rawItem("white_carpet"),
        rawItem("white_concrete"),
        rawItem("white_concrete_powder"),
        rawItem("white_dye"),
        rawItem("white_glazed_terracotta"),
        rawItem("white_shulker_box"),
        rawItem("white_stained_glass"),
        rawItem("white_stained_glass_pane"),
        rawItem("white_terracotta"),
        rawItem("white_tulip"),
        rawItem("white_wool"),
        rawItem("witch_spawn_egg"),
        rawItem("wither_rose"),
        rawItem("wither_skeleton_skull"),
        rawItem("wither_skeleton_spawn_egg"),
        rawItem("wolf_spawn_egg"),
        rawItem("wooden_axe"),
        rawItem("wooden_hoe"),
        rawItem("wooden_pickaxe"),
        rawItem("wooden_shovel"),
        rawItem("wooden_sword"),
        rawItem("writable_book"),
        rawItem("written_book"),
        rawItem("yellow_banner"),
        rawItem("yellow_bed"),
        rawItem("yellow_carpet"),
        rawItem("yellow_concrete"),
        rawItem("yellow_concrete_powder"),
        rawItem("yellow_dye"),
        rawItem("yellow_glazed_terracotta"),
        rawItem("yellow_shulker_box"),
        rawItem("yellow_stained_glass"),
        rawItem("yellow_stained_glass_pane"),
        rawItem("yellow_terracotta"),
        rawItem("yellow_wool"),
        rawItem("zoglin_spawn_egg"),
        rawItem("zombie_head"),
        rawItem("zombie_horse_spawn_egg"),
        rawItem("zombie_spawn_egg"),
        rawItem("zombie_villager_spawn_egg"),
        rawItem("zombified_piglin_spawn_egg"),
        FireResItem(),
        SplashFireResItem(),
        EnchantedBootsItem(true, 1),
        EnchantedBootsItem(true, 2),
        EnchantedBootsItem(true, 3),
        EnchantedBootsItem(false, 1),
        EnchantedBootsItem(false, 2),
        EnchantedBootsItem(false, 3),
        SoulSpeedBookItem(1),
        SoulSpeedBookItem(2),
        SoulSpeedBookItem(3),
        LootingSwordItem(1),
        LootingSwordItem(2),
        LootingSwordItem(3),
        RandomBarterItem(),
        SurfaceBlindPotionItem(),
        ForcePerchPotionItem(),
        KillZombiePigsPotionItem()
    )),
    ALL_HELMETS("All Helmets", isSpecificArmorSlotCategory = true, items = listOf(
        rawItem("golden_helmet"),
        rawItem("iron_helmet"),
        rawItem("diamond_helmet"),
        rawItem("leather_helmet"),
        rawItem("netherite_helmet"),
        rawItem("turtle_helmet"),
        rawItem("carved_pumpkin"),
    )),
    ALL_CHESTPLATES("All Chestplates", isSpecificArmorSlotCategory = true, items = listOf(
        rawItem("golden_chestplate"),
        rawItem("iron_chestplate"),
        rawItem("diamond_chestplate"),
        rawItem("leather_chestplate"),
        rawItem("netherite_chestplate"),
    )),
    ALL_LEGGINGS("All Leggings", isSpecificArmorSlotCategory = true, items = listOf(
        rawItem("golden_leggings"),
        rawItem("iron_leggings"),
        rawItem("diamond_leggings"),
        rawItem("leather_leggings"),
        rawItem("netherite_leggings"),
    )),
    ALL_BOOTS("All Boots", isSpecificArmorSlotCategory = true, items = listOf(
        rawItem("golden_boots"),
        EnchantedBootsItem(false, 1),
        EnchantedBootsItem(false, 2),
        EnchantedBootsItem(false, 3),
        rawItem("iron_boots"),
        EnchantedBootsItem(true, 1),
        EnchantedBootsItem(true, 2),
        EnchantedBootsItem(true, 3),
        rawItem("diamond_boots"),
        rawItem("leather_boots"),
        rawItem("netherite_boots"),
    )),
    ARMOR("Armor", listOf(
        rawItem("golden_helmet"),
        rawItem("golden_chestplate"),
        rawItem("golden_leggings"),
        rawItem("golden_boots"),
        EnchantedBootsItem(false, 1),
        EnchantedBootsItem(false, 2),
        EnchantedBootsItem(false, 3),
        rawItem("iron_helmet"),
        rawItem("iron_chestplate"),
        rawItem("iron_leggings"),
        rawItem("iron_boots"),
        EnchantedBootsItem(true, 1),
        EnchantedBootsItem(true, 2),
        EnchantedBootsItem(true, 3),
    )),
    TOOLS("Tools", listOf(
        rawItem("iron_pickaxe"),
        rawItem("iron_axe"),
        rawItem("iron_shovel"),
        rawItem("iron_sword"),
        rawItem("golden_pickaxe"),
        rawItem("golden_axe"),
        rawItem("golden_shovel"),
        rawItem("golden_sword"),
        rawItem("diamond_pickaxe"),
        rawItem("diamond_axe"),
        rawItem("diamond_shovel"),
        rawItem("diamond_sword"),
        rawItem("stone_pickaxe"),
        rawItem("stone_axe"),
        rawItem("stone_shovel"),
        rawItem("stone_sword"),
        rawItem("wooden_pickaxe"),
        rawItem("wooden_axe"),
        rawItem("wooden_shovel"),
        rawItem("wooden_sword"),
        rawItem("bow"),
        rawItem("crossbow"),
        rawItem("arrow"),
        rawItem("spectral_arrow"),
        rawItem("fishing_rod"),
        LootingSwordItem(1),
        LootingSwordItem(2),
        LootingSwordItem(3),
    )),
    FOOD("Food", listOf(
        rawItem("bread"),
        rawItem("apple"),
        rawItem("carrot"),
        rawItem("cooked_salmon"),
        rawItem("cooked_cod"),
        rawItem("cooked_porkchop"),
        rawItem("cooked_beef"),
        rawItem("cooked_mutton"),
        rawItem("cooked_chicken"),
        rawItem("golden_carrot"),
        rawItem("golden_apple"),
        rawItem("enchanted_golden_apple"),
        rawItem("suspicious_stew"),
        rawItem("mushroom_stew"),
        rawItem("rotten_flesh"),
    )),
    BARTERS("Barters", listOf(
        RandomBarterItem(),
        rawItem("ender_pearl"),
        rawItem("string"),
        rawItem("obsidian"),
        rawItem("crying_obsidian"),
        rawItem("glowstone_dust"),
        rawItem("soul_sand"),
        rawItem("gravel"),
        rawItem("nether_brick"),
        rawItem("fire_charge"),
        FireResItem(),
        SplashFireResItem(),
        rawItem("iron_nugget"),
        EnchantedBootsItem(true, 1),
        EnchantedBootsItem(true, 2),
        EnchantedBootsItem(true, 3),
        rawItem("magma_cream"),
        rawItem("quartz"),
        rawItem("leather"),
        SoulSpeedBookItem(1),
        SoulSpeedBookItem(2),
        SoulSpeedBookItem(3),
    )),
    MISC_SPEEDRUN_ITEMS("Misc Speedrun Items", listOf(
        rawItem("bow"),
        rawItem("crossbow"),
        rawItem("arrow"),
        rawItem("spectral_arrow"),
        rawItem("white_bed"),
        rawItem("yellow_bed"),
        rawItem("respawn_anchor"),
        rawItem("glowstone"),
        rawItem("ender_eye"),
        rawItem("blaze_rod"),
        rawItem("blaze_powder"),
        rawItem("nether_bricks"),
        rawItem("crafting_table"),
        rawItem("oak_boat"),
        rawItem("birch_boat"),
        rawItem("acacia_boat"),
        rawItem("spruce_boat"),
        rawItem("dark_oak_boat"),
        rawItem("jungle_boat"),
        rawItem("iron_bars"),
        rawItem("bucket"),
        rawItem("water_bucket"),
        rawItem("lava_bucket"),
        rawItem("fishing_rod"),
        rawItem("stick"),
        rawItem("iron_ingot"),
        rawItem("gold_ingot"),
        rawItem("diamond"),
        rawItem("cobblestone"),
        rawItem("oak_planks"),
        LootingSwordItem(1),
        LootingSwordItem(2),
        LootingSwordItem(3),
    )),
    MPK_POTIONS("MPK Command Potions", listOf(
        ForcePerchPotionItem(),
        SurfaceBlindPotionItem(),
        KillZombiePigsPotionItem()
    ))
}